module.exports = (__webpack_require__(0))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/HierarchyWidget.js from dll-reference girder_lib
// module id = 76
// module chunks = 0